import {Part} from "../part";
import {toiletThumbnail} from '../../../bvComponent/core/assets';
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../intermediatePart";
import {Shower} from "./shower";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../config";

export class Toilet extends Part {
  static id = 'Toilet';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.partThumbnail = toiletThumbnail;
    this.toilet = null;
    this.paperHolder = null;
    this.relatedItems = [];

  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Toilet": {
        relatedItemName = "toilet";
        RelatedItemClass = ToiletBody;
        break;
      }
      case "Paper Holder": {
        relatedItemName = "paperHolder";
        RelatedItemClass = PaperHolder;
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts() {
    return this.relatedItems.map(_ => new DesignNavigationItem(_.partName, _));
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
  }
}

class ToiletBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'toilet';
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.canBeDisabled = true;
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize && !IS_BATHROOM_OLD_BV_SCENE) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Toilet;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Toilet;
    }
  }
}


class PaperHolder extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'paper_holder';
    this.partName = 'Paper Holder';
    this.translateId = "visualizer.bathroom.accessories.paper_holder";
    this.canBeDisabled = true;
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.PaperHolder;
    }
  }
}


